"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("util");
exports.isThenable = (obj) => util_1.isFunction(obj.then);
//# sourceMappingURL=thenable.js.map